import React from 'react';

interface WindowFrameProps {
  url?: string;
  title?: string;
  onTitleChange?: (title: string) => void;
  isEditing?: boolean;
  children: React.ReactNode;
  className?: string;
  backgroundColor?: string;
  borderRadius?: number;
}

export const WindowFrame: React.FC<WindowFrameProps> = ({
  url,
  title,
  onTitleChange,
  isEditing = false,
  children,
  className = '',
  backgroundColor,
  borderRadius = 8
}) => {
  return (
    <div
      className={`w-full h-full overflow-hidden flex flex-col ${className}`}
      style={{
        borderRadius: `${borderRadius}px`,
        isolation: 'isolate'
      }}
    >
      {/* Title Bar */}
      <div
        className="bg-[#E8E8E8] px-3 py-3 flex items-center gap-2"
        style={{
          borderTopLeftRadius: `${borderRadius}px`,
          borderTopRightRadius: `${borderRadius}px`
        }}
      >
        {/* Window Controls */}
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full bg-[#FF5F57]"></div>
          <div className="w-3 h-3 rounded-full bg-[#FEBC2E]"></div>
          <div className="w-3 h-3 rounded-full bg-[#28C840]"></div>
        </div>

        {/* Title */}
        {isEditing && onTitleChange ? (
          <input
            type="text"
            value={title || ''}
            onChange={(e) => onTitleChange(e.target.value)}
            placeholder={url || "Window title"}
            className="flex-1 bg-white border border-gray-300 rounded px-2 py-0.5 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        ) : title ? (
          <div className="flex-1 text-sm text-gray-700 font-medium truncate">
            {title}
          </div>
        ) : url ? (
          <div className="flex-1 bg-white rounded px-2 py-0.5 text-gray-600 text-sm font-mono truncate">
            {url}
          </div>
        ) : null}
      </div>

      {/* Content */}
      <div
        className="flex-1 overflow-hidden"
        style={{
          lineHeight: 0,
          borderBottomLeftRadius: `${borderRadius}px`,
          borderBottomRightRadius: `${borderRadius}px`,
          ...(backgroundColor ? { backgroundColor } : {})
        }}
      >
        {children}
      </div>
    </div>
  );
};
